import React, { useEffect, useState } from "react";
import {
  add_user,
  get_users,
  remove_user,
  update_user,
} from "../../api/serverWrapper";
import "../../styles/Users/users.css";
import DataTable, { createTheme } from "react-data-table-component";
import { DeleteIcon, EditIcon } from "../../assets/SvgIcons";
import {
  conditionalRowStyles,
  customtableStyles,
} from "../../assets/tablestyle";
import Adduser from "./Adduser";
import UserInfo from "../../componant/User/UserInfo";
import { getData } from "../../utils/localstorage_constants";
import { USER_DATA, USER_ID } from "../../utils/localstorage_variables";
function Users() {
  let [users, setUsers] = useState();
  let [isadduserpopupvisible, setIsAddUserPopUpVisible] = useState(false);
  let [user, setUser] = useState(new UserInfo(null));
  let [isuseredit, setIsUserEdit] = useState(false);
  let [adminuser, setAdminUser] = useState(null);
  const usercolumn = [
    {
      name: "Name",
      selector: (row) => row.Name,
      center: true,
    },
    {
      name: "Mobile",
      selector: (row) => row.PhoneNumber,
      center: true,
    },
    {
      name: "Email",
      selector: (row) => row.Email,
      center: true,
    },

    {
      name: "Edit",
      selector: (row) => (
        <img
          style={{ height: "25px", width: "25px", marginRight: "25px" }}
          src={EditIcon}
          onClick={() => handleEditUser(row)}
        />
      ),
      width: "80px",
      headerStyle: () => {
        return {
          textAlign: "right",
        };
      },
    },
    {
      name: "Delete",
      selector: (row) => (
        <img
          style={{ height: "25px", width: "25px" }}
          src={DeleteIcon}
          onClick={() => handleRemoveUser(row)}
        />
      ),
      width: "80px",
    },
  ];

  createTheme("solarized", {
    background: {
      default: "var(--main-background-color)",
    },
  });
  useEffect(() => {
    loadInitialData();
  }, []);

  const loadInitialData = async () => {
    let userdata = getData(USER_DATA);

    adminuser = userdata;
    setAdminUser(adminuser);
    let userresp = await get_users(userdata.id);
    users = userresp.data;

    setUsers(users);
  };

  const handleRemoveUser = async (user) => {
    let resp = await remove_user(user);

    if (resp.success) {
      alert("User removed successfully");
      loadInitialData();
    } else {
      alert(resp.message);
    }
  };

  const handleEditUser = async (user) => {
    user = new UserInfo(user);
    setUser(user);
    await handleEditUserPopUp();
    await handleAddUserPopup();
  };
  const handleEditUserPopUp = async () => {
    isuseredit = !isuseredit;
    setIsUserEdit(isuseredit);
  };
  const handleAddUserPopup = async () => {
    isadduserpopupvisible = !isadduserpopupvisible;
    setIsAddUserPopUpVisible(isadduserpopupvisible);
  };

  const handleUserDetails = (event) => {
    const { name, value } = event.target;
    // user[name] = value;
    // setUser(user);

    setUser((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAddUser = async () => {
    try {
      delete user.id;
      user.CreatedByUserId = adminuser?.id;
      setUser(user);

      let useradd = await add_user(user);

      if (useradd.success) {
        alert("User added succesfully..");
      } else {
        alert("Something went wrong..");
      }
      user = new UserInfo(null);
      setUser(user);

      handleAddUserPopup();
      loadInitialData();
    } catch (error) {
      return error;
    }
  };

  const handleUpdateUser = async () => {
    console.log(user);
    try {
      let useradd = await update_user(user);

      console.log(useradd);

      if (useradd.success) {
        alert("User update succesfully..");
      } else {
        alert("Something went wrong..");
      }
      handleEditUser(null);
      loadInitialData();
    } catch (error) {
      return error;
    }
  };

  return (
    <div className="users_container">
      <div className="d-flex justify-content-end my-2">
        <button className="btn" onClick={() => handleAddUserPopup()}>
          Add User
        </button>
      </div>
      <DataTable
        data={users}
        columns={usercolumn}
        customStyles={customtableStyles}
        conditionalRowStyles={conditionalRowStyles}
        fixedHeader
        theme="solarized"
        // onRowClicked={(row) => handleProductSelection(row)}
        fixedHeaderScrollHeight="600px"
      />

      {isadduserpopupvisible && (
        <Adduser
          user={user}
          handleAddUserPopup={handleAddUserPopup}
          handleUserDetails={handleUserDetails}
          handleAddUser={handleAddUser}
          isuseredit={isuseredit}
          handleUpdateUser={handleUpdateUser}
        />
      )}
    </div>
  );
}

export default Users;
